import React from "react";
import { getIconUrl } from "../../../../services/asset";
import styles from "./styles/SortOptionToggle.scss";

function SortOptionToggle({ onToggleModal }) {
  return (
    <span
      tabIndex={0}
      role="button"
      onClick={onToggleModal}
      className={styles.sortBtn}
    >
      <img alt={"Sortiraj"} src={getIconUrl("sort.svg")} />
      <span>{"Sortiraj"}</span>
    </span>
  );
}

export default SortOptionToggle;



// WEBPACK FOOTER //
// ./src/components/SortOption/SortOptionMobile/SortOptionToggle/index.tsx